import { ISOLocaleCode } from "../../constants/route.constants";
import type { TouPrivacyInput } from "../../types/user.types";
import { REGEX } from "../../helpers/regex.helper";

export function getRegistrationLocale(language: string): ISOLocaleCode {
  const code = language.trim().toLowerCase().split(/[-_]/)[0];
  return Object.values(ISOLocaleCode).find(value => value === code) || ISOLocaleCode.EN;
}

export const validProfileName = (value: string) => {
  const name = value.trim();
  return (
    name.length > 0 &&
    name.length <= 64 &&
    !/[<>]|\p{Cc}|\p{Extended_Pictographic}/u.test(name) &&
    REGEX.commonNameFieldRegex.test(name) &&
    REGEX.emojiRegex.test(name)
  );
};

export function buildRegistrationConsent(
  terms: (Omit<TouPrivacyInput, "isoLocaleCode"> & { isoLocaleCode?: string | null })[],
  locale: ISOLocaleCode,
): TouPrivacyInput[] {
  return terms.map(({ touVersionMasterId, type, version, isoLocaleCode }) => ({
    touVersionMasterId,
    type,
    version,
    isoLocaleCode: isoLocaleCode?.trim() || locale,
  }));
}
